/** Same-tab and cross-tab synchronization for existing browser preference keys. */
const EVENT = "gamja:browser-preference";
const sessionValues = new Map<string, string>();

export function readBrowserPreference(key: string): string | null {
  if (typeof window === "undefined") return null;
  if (sessionValues.has(key)) return sessionValues.get(key)!;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return sessionValues.get(key) ?? null;
  }
}

export function writeBrowserPreference(key: string, value: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, value);
    sessionValues.delete(key);
  } catch {
    sessionValues.set(key, value);
  }
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeBrowserPreferences(callback: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key) sessionValues.delete(event.key);
    else sessionValues.clear();
    callback();
  };
  window.addEventListener(EVENT, callback);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT, callback);
    window.removeEventListener("storage", onStorage);
  };
}
